
$(document).on('click', '.hk-element-sub-option', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('sub_tab'), 10); // 1,2,3...
  var selling_plan = parseInt($('.hk-element-option.hk-active').attr('selling_plan'), 10); // 1,2,3...

  if (!tab) return;

  // Remove active from siblings
  $('.hk-element-sub-option').removeClass('hk-active');

  // Add active to current
  $this.addClass('hk-active');

$('.hk-sub-trigger').hide();
$('.hk-sub-trigger[sub_tab="'+tab+'"]').show();
if (tab == 1){
$('.hk-checkout-button').attr('selling_plan',selling_plan);
$('.hk-pdp-pdt-sub-heading2 strong').text(' Subscribe & Save');
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
$('.hk-pdp-pdt-sub-heading2 strong').text('One Time Purchase');
}
});



$(document).on('click', '.hk-element-option', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('data_tab'), 10); // 1,2,3...
  var quantity = parseInt($(this).attr('quantity'), 10); // 1,2,3...

  if (!tab) return;

  // Remove active from siblings
  $('.hk-element-option').removeClass('hk-active');

  // Add active to current
  $this.addClass('hk-active');

$('.hk-quantity-trigger').hide();
$('.hk-quantity-trigger[data_tab="'+tab+'"]').show();
$('.hk-checkout-button').attr('quantity',quantity);
var selected_title = $this.find('.hk-option-title').text();
$('.hk-pdp-pdt-sub-heading1 strong').text(selected_title);
});



$(document).on("click", "a[href='#ingredients']", function (e) {
  e.preventDefault();
 $('.hk-pdp-popup').addClass('hk-active');
});


$(document).on("click", ".hk-pdp-popup-top .hk-icon-with-text-flex .hk-element-image", function (e) {
  e.preventDefault();
 $('.hk-pdp-popup').removeClass('hk-active');
});




$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.hk-pdp-pdt-sub-heading1').scrollIntoView({
    behavior: 'smooth'
  })
});





/*
$(document).ready(async function () {

  const $deliveryEl = $('.hk-pdp-pdt-estimated');

  if (!$deliveryEl.length) return;

  // ===== Date 5 days ahead =====
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 5);

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const formattedDate = `${months[futureDate.getMonth()]} ${futureDate.getDate()}, ${days[futureDate.getDay()]}`;

  // ===== Default zipcode =====
  let zipcode = '00000';

  try {

    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();

    if (data && data.postal) {
      zipcode = data.postal;
    }

  } catch (e) {

    console.log('Zipcode fetch failed');

  }

  // ===== Replace placeholders =====
  let updatedHtml = $deliveryEl.html()
    .replace('[zipcode]', zipcode)
    .replace('[stock_date]', formattedDate);

  $deliveryEl.html(updatedHtml);

});
*/






$(document).ready(async function () {

  const $deliveryEl = $('.hk-pdp-pdt-estimated');

  if (!$deliveryEl.length) return;

  // ===== Date 5 days ahead =====
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 5);

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const formattedDate = `${months[futureDate.getMonth()]} ${futureDate.getDate()}, ${days[futureDate.getDay()]}`;

  // ===== Default location =====
  let locationText = 'Your Area';

  try {

    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();

    if (data) {
      const state = data.region || '';
      const country = data.country_name || '';

      if (state && country) {
        locationText = `${state}, ${country}`;
      } else if (country) {
        locationText = country;
      }
    }

  } catch (e) {

    console.log('Location fetch failed');

  }

  // ===== Replace placeholders =====
  let updatedHtml = $deliveryEl.html()
    .replace('[zipcode]', locationText)
    .replace('[stock_date]', formattedDate);

  $deliveryEl.html(updatedHtml);

});